import { Injectable, Inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { AuthService } from './auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserInfo } from '../userInfo';
import { DOCUMENT } from '@angular/common';
import { Alert } from 'selenium-webdriver';
import { UserPermissions } from '../UserPermissions';
import { userPermissionsService } from '../shared/userPermissions.service';
import { HttpService } from '../shared/services/HttpClientServices/Http.service';
import { of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { RefreshTokenService } from './Services/refresh-token.service';
@Injectable()
export class AdminRouteGuard  {
    constructor(private _authService: AuthService, private jwtHelper: JwtHelperService, private _router: Router,
        @Inject(DOCUMENT) private document: Document, public activatedRoute: ActivatedRoute,
         public userPermissions: userPermissionsService,private http:HttpService,
        private refreshTokenService: RefreshTokenService) { }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        var token = localStorage.getItem("ODataToken");
        if (token && this.jwtHelper.isTokenExpired(token))
            return this.refreshTokenService.tryRefreshingTokens().pipe(map((response: any)=>{
                if(response){
                  localStorage.setItem("ODataToken", response.Token);
                  localStorage.setItem("jwt", response.Token);
                  localStorage.setItem("refreshToken", response.RefreshToken);
                  return this.isAuthorized(route);
                }
              }),
              catchError((error)=>{
                    localStorage.removeItem('ODataToken');
                    localStorage.setItem('redirectTo', window.location.href);
                    this._router.navigate(["login"]);
                    return throwError(error);
              }
            ))
        return of(this.isAuthorized(route));
    }
    isAuthorized(route) : boolean{
        var token = localStorage.getItem("ODataToken");
        if (token && !this.jwtHelper.isTokenExpired(token)) {
            return this.CheckIfUserAuthorized(route['_routerState'].url);
        }
        else {
            var screenId = route.params['screenID'];
            if (screenId == "145" || screenId == "151" || screenId == "216" || screenId == "119") {
                var user = { 'Language': '', 'IgnorSecurity': 'true' };


                var url = route.params['ID'].split('&&');
                if (url.includes('Lang:ar')) {
                    user.Language = '1';
                }
                else if (url.includes('Lang:en')) {
                    user.Language = '2';
                }
                else {
                    user.Language = '2';
                }

                let keys = Object.keys(localStorage);
                var i, results = [];
                for (i in localStorage) {
                    if (localStorage.hasOwnProperty(i)) {
                        if (i.match('FilterValues') || (!'FilterValues' && typeof i === 'string')) {
                            localStorage.removeItem(i);
                        }
                    }
                }

                this.loadUserClaims(user);
                return true;
            }

        }

        //made for redircting to the same page --Competition enhancement
        localStorage.setItem('redirectTo', window.location.href);
        this._router.navigate(["login"]);
        return false;
    }
    Permissions: any;
  CheckIfUserAuthorized(route: string): boolean {
      let fullRoute=route
        if(route.includes('?')){  // for route like "/route?param=value"
            route = route.split('?')[0]
      }
       

    (async () => {
    await this.userPermissions.CheckSecurityKey(route);
        this.Permissions = UserPermissions;
        if (this.Permissions.CanRead) {
            return true;
        }
        else {
            this._router.navigate(['/unauthorized']);
            return false;
        }
    })();
        return true;
    }

    isLoggedIn() {
        var token = localStorage.getItem("ODataToken");
        if (token && !this.jwtHelper.isTokenExpired(token))
            return true;
        else return false;
    }

    async loadUserClaims(user: any) {
        if (user.BusinessUnit)
            UserInfo.BUID = user.BusinessUnit;
        if (user.BusinessUnitName)
            UserInfo.BusinessUnitName = user.BusinessUnitName;
        if (user.BusinessUnitAName)
            UserInfo.BusinessUnitAName = user.BusinessUnitAName;
        if (user.Username)
            UserInfo.UserName = user.Username;
        if (user.Language)
            UserInfo.Language = user.Language;
        if (user.UserCode) {
            UserInfo.CurrentSalesmanNo = user.UserCode;
            UserInfo.UserCode = user.UserCode;
            UserInfo.UserName = user.Username;
        }
        if (user.Token) {
            UserInfo.AccessToken = user.Token;
            localStorage.setItem("jwt", user.Token);
        }
        if (user.IgnorSecurity == 'true') {
            localStorage.setItem("IgnorSecurity", user.IgnorSecurity);
        }


        if (user) {
            localStorage.setItem("userinfo", JSON.stringify(user));
            if (UserInfo.Language == 1) {
                //this.loadStyle("./assets/Theme/css/rtl/style.css", "stylear");
                //this.loadStyle("./assets/Theme/css/rtl/responsive.css", "responsivear");
                const htmlTag = this.document.getElementsByTagName('html')[0];
                htmlTag.setAttribute("dir", "rtl");
            }
            else {
                //this.loadStyle("./assets/Theme/css/style.css", "styleen");
                //this.loadStyle("./assets/Theme/css/responsive.css", "responsivear");
            }
        }
    }

    loadStyle(styleName: string, clienttheme: string) {
        const head = this.document.getElementsByTagName('head')[0];

        let themeLink = this.document.getElementById(
            clienttheme
        ) as HTMLLinkElement;

        if (themeLink) {
            themeLink.href = styleName;
        } else {
            const style = this.document.createElement('link');
            style.id = clienttheme;
            style.rel = 'stylesheet';
            style.href = `${styleName}`;
            style.type = "text/css";
            head.appendChild(style);
        }
    }
}
